var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineArrowStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Line-Arrow-Synchronize-1--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Line Arrow Synchronize 1 Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-arrow-synchronize-1--arrows-loading-load-sync-synchronize-arrow-reload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32.91399857142857 21.255885214285716C31.65336085714286 28.031149714285714 25.710695571428577 33.160714285714285 18.57 33.160714285714285c-6.678727028571429 0 -12.309363257142858 -4.4873078571428575 -14.041493271428573 -10.611428571428572",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.225391271428572 15.884114785714287C5.486108571428572 9.108850285714286 11.42874732857143 3.9792857142857145 18.569416371428574 3.9792857142857145c6.678727028571429 0 12.3093102 4.4873078571428575 14.041625914285715 10.611428571428572",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.8084898542857144 10.795961314285716c-0.040867264285714286 2.1000547714285713 0.7664661385714285 3.7964773285714286 2.421994902857143 5.089214614285715 2.1000813 0.040854 3.7964773285714286 -0.7664900142857144 5.089214614285715 -2.4220055142857144",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.34189342857143 26.34403868571429c0.040854 -2.1000547714285713 -0.7664104285714286 -3.7964773285714286 -2.422058571428572 -5.089214614285715 -2.1000017142857144 -0.040854 -3.7965038571428575 0.7664900142857144 -5.089241142857143 2.4220055142857144",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrowStreamlineFlex);
export default __webpack_public_path__ + "static/media/Line-Arrow--Streamline-Flex.d8995c6995e135182fa3e7efe6a128bf.svg";
export { ForwardRef as ReactComponent };